import * as yup from 'yup';
import { enabledValidation } from 'utils/yup';
import { TFunction } from 'i18next';

export const CreateForm = (t: TFunction): any =>
  yup.object().shape({
    floor: yup
      .number()
      .integer(t('schema-luxury-box-form-floor-integer'))
      .required(t('schema-luxury-box-form-floor-required')),
    identifierOnFloor: yup.string().required(t('schema-luxury-box-form-identifierOnFloor-required')),
    usesCheckingAccount: enabledValidation(t),
    commerces: yup.array().of(yup.string()).min(1, t('schema-luxury-box-form-commerces-are-required')),
  });

export const EditForm = (t: TFunction): any =>
  yup.object().shape({
    floor: yup
      .number()
      .integer(t('schema-luxury-box-form-floor-integer'))
      .required(t('schema-luxury-box-form-floor-required')),
    identifierOnFloor: yup.string().required(t('schema-luxury-box-form-identifierOnFloor-required')),
    usesCheckingAccount: enabledValidation(t),
    commerces: yup.array().of(yup.string()).min(1, t('schema-luxury-box-form-commerces-are-required')),
  });
